import { Invoice } from '@features/invoices/types/invoices/invoice'

import { ExternalInvoiceBalanceModifierReference } from '../elements/InvoiceViewActions/enums/ExternalInvoiceBalanceModifierReference'
import { getExternalInvoiceBalanceModifierReference } from './getExternalInvoiceBalanceModifierReference'

const isInvoiceRef = (t?: ExternalInvoiceBalanceModifierReference) =>
  t === ExternalInvoiceBalanceModifierReference.Invoice || t === ExternalInvoiceBalanceModifierReference.ExternalInvoice

const resolveInvoiceRef = (invoice: Invoice | undefined, originalType?: ExternalInvoiceBalanceModifierReference) => {
  if (invoice?.referredCreditnoteId) {
    return {
      modifierType: ExternalInvoiceBalanceModifierReference.CreditNote,
      modifierId: invoice.referredCreditnoteId,
    }
  }
  if (invoice?.invoiceId) {
    return {
      modifierType: originalType || ExternalInvoiceBalanceModifierReference.ExternalInvoice,
      modifierId: invoice.invoiceId,
    }
  }
  return undefined
}

export const transformExternalInvoiceModifierReference = (
  invoice: Invoice | undefined,
  modifierReference: string | null,
): string | null => {
  const parsed = modifierReference ? getExternalInvoiceBalanceModifierReference(modifierReference) : undefined
  const resolved = (isInvoiceRef(parsed?.modifierType) && resolveInvoiceRef(invoice, parsed?.modifierType)) || parsed

  return resolved?.modifierType && resolved?.modifierId ? `${resolved.modifierType}:${resolved.modifierId}` : null
}
